import PropTypes from 'prop-types';
var propTypes = {
  button: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  image: PropTypes.string,
  label: PropTypes.string,
  link: PropTypes.element,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  size: PropTypes.oneOf([24, 28, 36, 48, 72, 96, 144])
};
export default propTypes;